<template>
<v-app id="stats">
    <v-toolbar color="primary" class="empty-stats--toolbar" height=16px flat dark dense>
    </v-toolbar>
    <v-toolbar color="primary" class="stats--toolbar" flat dark dense>
        <v-spacer></v-spacer>
           
            <v-menu offset-y>
            <v-btn @click="dashboard" depressed
                slot="activator"
                color="primary"
                dark>
                Dashboard
            </v-btn>
            </v-menu>
            <v-btn icon @click="reload()">
            <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn icon @click="handleFullScreen()">
            <v-icon>fullscreen</v-icon>
            </v-btn>
            <v-btn icon @click="logout()">
            <v-icon>exit_to_app</v-icon>
        </v-btn>
    </v-toolbar>

    <template>
        <vue-perfect-scrollbar class="chat-history--scrollbar">
        <table>              
      
         <tr>
              <td><b>Max negotiotions per week</b></td>
               <td>
              <v-text-field v-model="settings.maxNegoCount" type="number" @keypress="isNumber($event)">
              </v-text-field>
            </td>
           </tr>
         <tr>
              <td><b>Exceptions for offers above x EUR </b></td>
              <td>
              <v-text-field v-model="settings.aboveException" type="number" @keypress="isNumber($event)">
              </v-text-field>              
            </td>
           </tr>

            <tr>
              <td><b>Warning email will be sent to: </b></td>
              <td>
              <v-textarea v-model="settings.warningEmail" style="min-width:1000px">
              </v-textarea>              
            </td>
            </tr>
            <tr>
              <td><b>Email to analyze unsucesfull: </b></td>
              <td>
              <v-textarea v-model="settings.emailToAnalyze" style="min-width:1000px">
              </v-textarea>              
            </td>
            </tr>
            <tr>
              <td><b>Email Template 1: </b></td>
              <td>
              <v-textarea v-model="settings.emailTemplate1"  style="min-width:1000px" >
              </v-textarea>              
            </td>
            </tr>
             <tr>
              <td><b>Email Template 2: </b></td>
              <td>
              <v-textarea v-model="settings.emailTemplate2"  style="min-width:1000px" >
              </v-textarea>              
            </td>
            </tr>
             <tr>
              <td><b>Email Template 3: </b></td>
              <td>
              <v-textarea v-model="settings.emailTemplate3"  style="min-width:1000px" >
              </v-textarea>              
            </td>
            </tr>

            <tr>
              <td><b>Reminder Template: </b></td>
              <td>
              <v-textarea v-model="settings.reminderTemplate"  style="min-width:1000px" >
              </v-textarea>              
            </td>
            </tr>
  
        </table>
        <v-btn small round @click="saveSettings">
          Save
        <v-icon small right>
          save
        </v-icon>
        </v-btn>
        </vue-perfect-scrollbar>
      </template>

  

</v-app>
</template>

<script>
import API from '@/api';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    components: {
      VuePerfectScrollbar
      
    }, 

    data: () => ({
        settings: ''
    }),
    mounted () {
        this.getSettings();
    },
    methods:{
        dashboard(){
            this.$router.push('/chat')
        },
        handleFullScreen () {
            Util.toggleFullScreen()
        },
        logout () {
            window.getApp.$emit('APP_LOGOUT')
        },        
        async getSettings () {
            this.settings = await API.getSettings({});
        },
        async saveSettings() {
            let password = prompt("Please enter your password:", "");
            this.settings.password = password;
            await API.saveSettings(this.settings);
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode != 9)) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    }
    
}
</script>